import { BUILDER_ROW_TYPES } from '../constants/campaignBuilder.js';
import { BuilderTableColumn, BuilderTableRow } from '../pages/Builder/types.js';
import { ChannelMixVersionResponse } from './buyingPlanVersions.js';

export type FieldMeta = { name: string; label: string };

export enum VersionsOrderStatus {
  Draft = 'draft',
  Booked = 'booked',
  Invoiced = 'invoiced',
  Rejected = 'rejected',
}

export type Version = {
  id: number;
  name: string;
  createdAt: string;
  approvedAt: string | null;
  approvedBy: string | null;
  lastUpdate: string;
  isCurrent: boolean;
  description: string;
  canBeDeleted: boolean;
  canBeDuplicated: boolean;
  channelMixVersionData?: ChannelMixVersionResponse;
  shouldExpand?: boolean;
  mediaPlan?: number;
};

export type VersionFieldsData = {
  adserverCost: string | null;
  budget: string | null;
  calculatedClicks: string | null;
  calculatedConversions: string | null;
  calculatedImpressions: string | null;
  calculatedLeads: string | null;
  calculatedVideoViews: string | null;
  compoundBudget: string | null;
  cr: string | null;
  ctr: string | null;
  dateFrom: string | null;
  dateTo: string | null;
  dspCost: string | null;
  vtr: string | null;
};

export type VersionItem = {
  fields: VersionFieldsData;
  type: BUILDER_ROW_TYPES;
  subItems?: (FieldMeta & {
    fields: VersionFieldsData;
    type: BUILDER_ROW_TYPES;
  })[];
} & FieldMeta;

export type VersionForTableView = {
  id: number;
  name: string;
  items: VersionItem[];
  totals: VersionFieldsData;
  isCurrent: boolean;
};

export type KpisType = {
  ctr?: KpisValuesType;
  vtr?: KpisValuesType;
  cr?: KpisValuesType;
  impression?: KpisValuesType;
  clicks?: KpisValuesType;
  leads?: KpisValuesType;
  conversion?: KpisValuesType;
  video_views?: KpisValuesType;
};

export type BudgetType = {
  mediaBudget?: BudgetValuesType;
  adserverCost?: BudgetValuesType;
  dspCost?: BudgetValuesType;
  otherTechCost?: BudgetValuesType;
  total?: string;
};

export type BudgetValuesType = {
  current?: string | null;
  difference?: string | null;
  previous?: string | null;
};

export type ChannelMixValuesType = {
  current?: string | null;
  currentPercent?: string | null;
  difference?: string | null;
  previous?: string | null;
};

export type KpisValuesType = {
  current?: string | number | null;
  previous?: string | number | null;
  difference?: number | null;
};

export type DateRange = {
  dateFrom?: string | null;
  dateTo?: string | null;
};

export type ChannelMixVersionType = {
  social?: ChannelMixValuesType;
  dem?: ChannelMixValuesType;
  programmaticRadio?: ChannelMixValuesType;
  search?: ChannelMixValuesType;
  display?: ChannelMixValuesType;
  video?: ChannelMixValuesType;
  native?: ChannelMixValuesType;
  mobile?: ChannelMixValuesType;
  dooh?: ChannelMixValuesType;
  addressableTv?: ChannelMixValuesType;
};

export enum VersionView {
  Table = 'table',
  Mix = 'pie',
}

export enum VersionsEventEmitterAction {
  SORT_VERSIONS = 'SORT_VERSIONS',
  OPEN_MODAL = 'OPEN_MODAL',
  CLOSE_MODAL = 'CLOSE_MODAL',
  OPEN_VERSION = 'OPEN_VERSION',
  DUPLICATE_VERSION = 'DUPLICATE_VERSION',
  DELETE_VERSION = 'DELETE_VERSION',
}

export type channelsArrayType = {
  label: string;
  bgColor: string;
  color: string;
  icon: any;
  values: ChannelMixValuesType;
};

export type VersionsTableRow = Omit<BuilderTableRow, 'original'> & {
  original: {
    currencySign: string;
    id: number;
    type: string;
    isCurrentVersion: boolean;
    parent: number;
    subRows: Array<{ id: number }>;
    dateFrom: string;
    dateTo: string;
    nameKey: string;
    label: string;
    name: string;
    versionId: number;
    logo?: string;
  };
};

export type VersionTableColumn = Pick<
  BuilderTableColumn,
  'Header' | 'decimals' | 'id' | 'isCurrency' | 'isInitialOpened' | 'width'
>;
